import { statusField } from "../../../../helper/validField";
import { BcFieldProps } from "../../../interface/props/bcfield";
import { BCInput, BCInputCont } from "../../../styled/global.styled";

const InputField = ({field, register, isRequired, errors, touchedFields, dirtyFields }: BcFieldProps ) => (
    <BCInputCont className="bc-form-field">
        <BCInput
            id={field.item}
            className={`bc-input ${statusField(errors[field.item], touchedFields[field.item], !dirtyFields[field.item] , !errors[field.item])}`}
            placeholder={field.placeholder}
            aria-label={field.label}
            type={field.type}
            {...register(field.item, { required: isRequired })}
        />
        <label htmlFor={field.item}>{field.label}</label>
        <span>{errors[field.item] ? 'Este campo es Obligatorio *' :  'Campo Obligatorio *'} </span>
    </BCInputCont>
);

export default InputField;